import React from 'react';

import { hiddenOffScreen } from './HiddenPageTitle.styles';

export const HiddenPageTitle = ({ children }: { children: string }) => (
  <h1 css={hiddenOffScreen}>{children}</h1>
);
